import { Link, LinkOff } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import type { MouseEvent } from "react";

const LINK_LABEL = "Link heat to process";
const UNLINK_LABEL = "Unlink heat from process";

const preventFocusTransfer = (event: MouseEvent<HTMLButtonElement>) => {
  event.preventDefault();
};

interface HeatLinkButtonProps {
  isLinked: boolean;
  disabled?: boolean;
  onLink: () => void | Promise<void>;
  onUnlink: () => void | Promise<void>;
}

export const HeatLinkButton = ({
  isLinked,
  disabled = false,
  onLink,
  onUnlink,
}: HeatLinkButtonProps) => {
  const label = isLinked ? UNLINK_LABEL : LINK_LABEL;

  return (
    <Tooltip title={label}>
      <IconButton
        size="small"
        color="primary"
        disabled={disabled}
        aria-label={label}
        onMouseDown={preventFocusTransfer}
        onClick={isLinked ? onUnlink : onLink}
      >
        {isLinked ? <LinkOff /> : <Link />}
      </IconButton>
    </Tooltip>
  );
};
